module.exports = __webpack_public_path__ + "static/profile-7b335454751b872b8b0b4205e67048db.jpg";